import BrowseBoardsStore from "@/areas/demand/stores/BrowseBoardsStore";
import CreateBoardStore from "@/areas/demand/stores/CreateBoardStore";

export default class DemandRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.browseBoardsStore = new BrowseBoardsStore(this);
    this.createBoardStore = new CreateBoardStore(this);
  }
}
